import { useTranslations } from 'next-intl';
import Filter from './Filter';
import GradeFilter from './GradeFilter';
import useI18n from '@hooks/i18n/useI18n';

interface IHorizontalFiltersProps {
  collectionLevel?: number;
  children: React.ReactNode;
}

const HorizontalFilters: React.FC<IHorizontalFiltersProps> = ({
  collectionLevel = 0,
  children,
}) => {
  const tCatalog = useTranslations('Catalog');
  const { isFrenchMarket } = useI18n();

  return (
    <div className="desktop-only tw-flex tw-flex-row tw-flex-wrap tw-gap-2">
      {children}
      {collectionLevel <= 2 ? (
        <Filter title={tCatalog('shelf')} isToggled attribute="shelfs" />
      ) : null}
      <Filter
        title={tCatalog('diet')}
        isToggled={!(collectionLevel <= 2)}
        attribute="diets"
      />
      <Filter title={tCatalog('values')} attribute="values" />
      <Filter title={tCatalog('brand')} attribute="vendor" />
      <GradeFilter
        title={tCatalog('nutriscore')}
        attribute="meta.marketing.nutriscore_grade"
      />
      {isFrenchMarket && (
        <GradeFilter title={tCatalog('greenscore')} attribute="meta.marketing.environmentalscore_grade" />
      )}
    </div>
  );
};

export default HorizontalFilters;
